module.exports = __webpack_public_path__ + "static/media/52.e7937eef.jpg";